import one from '../assets/svg/services/one.webp'
import two from '../assets/svg/services/two.webp'
import three from '../assets/svg/services/three.webp'
import four from '../assets/svg/services/four.webp'
import five from '../assets/svg/services/five.webp'

export const servicesData = [
    {
        id: 1,
        title: 'بهترین پزشکان زیبایی',
        desc: 'مشاوره با متخصصین برتر زیبایی',
        color: '#e91e8c',
        bg: '#fde8f3',
        icon: one
    },
    {
        id: 2,
        title: 'بهترین برندها',
        desc: 'محصولات اصل آرایشی و بهداشتی',
        color: '#c2185b',
        bg: '#fce4ec',
        icon: two
    },
    {
        id: 3,
        title: 'بهترین مراکز زیبایی',
        desc: 'کلینیک‌های معتبر و پیشرفته',
        color: '#ff6ba8',
        bg: '#fff0f7',
        icon: three
    },
    {
        id: 4,
        title: 'لاغری',
        desc: 'کاهش وزن اصولی و پایدار',
        color: '#ad1457',
        bg: '#fce4ec',
        icon: four
    },
    {
        id: 5,
        title: 'پوست و مو',
        desc: 'درمان‌های تخصصی پوست و مو',
        color: '#ff4f93',
        bg: '#ffe8f4',
        icon: five
    },
]
